import { render, staticRenderFns } from "./quesSuccess2_2.vue?vue&type=template&id=564be58a"
import script from "./quesSuccess2_2.vue?vue&type=script&lang=js"
export * from "./quesSuccess2_2.vue?vue&type=script&lang=js"
import style0 from "./quesSuccess2_2.vue?vue&type=style&index=0&id=564be58a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports